import { combineReducers } from 'redux';
import * as _ from 'lodash';
import {
    SET_API, 
    LOGIN_REQUEST, 
    LOGIN_SUCCESS, 
    LOGIN_FAILED,
    LOGOUT,
    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    REGISTER_ERROR,
    SET_ERROR,
    CLEAR_ERROR,
    GOT_SERVICES
} from './actions';

function apiReducer(state = "", action) {
    switch(action.type) {
        case SET_API:
            return action.apiRoot;
        default:
            return state;
    }
}

const initRegState = {
    newUser: {
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        street1: '',
        street2: '',
        zip: '', 
        phone: ''
    },
    inputErrors: {
        email: false,
        password: false,
        firstName: false,
        lastName: false,
        street1: false,
        zip: false, 
        phone: false 
    },
    loading: false,
    status: undefined,
    error: false,
    errorText: ''
}
function registrationReducer(state=initRegState, {type, ...action}) {
    switch(type) {
        case "REG_FORM_UPDATE":
            return {...state, newUser: {...state.newUser, ...action.newValue} };
        case "REG_INPUT_ERROR":
            return {...state, inputErrors: {...state.inputErrors, [action.key]: true}};
        case REGISTER_REQUEST:
            return {...state, loading: true };
        case REGISTER_SUCCESS:
            return {...state, loading: false, error: false, status: action.status };
        case REGISTER_ERROR:
            return {...state, loading: false, error: true, errorText: action.error, status: action.status}
        default:
            return state;
    }
}

const loginInitState = {logged: false, status: 0, error: false, errorText: "", loading: false};
function loginReducer(state = loginInitState, action) {
    switch(action.type) {
        case LOGIN_REQUEST:
            return {...state, loading: true, error: false};
        case LOGIN_SUCCESS:
            return {...state, logged: true, loading: false, status: action.status};
        case LOGIN_FAILED:
            return  {...state, logged: false, loading: false, status: 401, error: true};
        case LOGOUT:
            return {logged: false}; 
        default:
            return state;
    }
}

function userReducer(user={}, {type, ...action}) {
    switch(type) {
        case LOGIN_SUCCESS:
            return {...user, ...action.user};
        case LOGOUT:
            return {};
        case "ADD_SERVICE":
            user.services.push(action.service);
            return {...user };
        default:
            return user;
    }
}

function serviceReducer(state={
    allServices:[], 
    maintanenceServices:[], 
    landscapingServices:[], 
    fertilizationServices:[], 
    pressureWashingServices:[],
    loading: false,
    quoteRequestSent: false
}, {type, services}) {
    switch(type) {
        case GOT_SERVICES:
            return {...state, 
                allServices: services,
                maintanenceServices: services.filter(el => el.category === "lawn-maintenance"),
                landscapingServices: services.filter(el => el.category === "landscaping"),
                fertilizationServices: services.filter(el => el.category === "fertilization"),
                pressureWashingServices: services.filter(el => el.category === "pressure-washing")
            };
        case "QUOTE_REQUEST":
            return {...state, loading: true};
        case "QUOTE_SUCCESS":
        return {...state, loading: false, quoteRequestSent: true};
        case "QUOTE_FAIL":
            return {...state, loading: false};
        case "RESET_QUOTE_SNACK":
            return {...state, quoteRequestSent: false};
        default:
            return state;
    }
}

const rootReducer = combineReducers({
    api: apiReducer,
    registration: registrationReducer,
    auth: loginReducer,
    services: serviceReducer,
    user: userReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers.js